import { Chip, Stack, Tooltip, Typography } from '@mui/material'
import { Info } from '@mui/icons-material'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

const endedWithinAcademicYear = (endDate, academicYear) => {
  if (!academicYear || !endDate) return false
  const end = dayjs(endDate)
  return !end.isBefore(dayjs(academicYear.startDate), 'day') && !end.isAfter(dayjs(academicYear.endDate), 'day')
}

export default function TeacherCell({ enrollments = [] }) {
  const academicYear = useSelector(state => state.session?.academicYear)
  const staffRole = useSelector(state => state.lookup?.courseSessionsEnrollmentType)

  const inactiveIds = new Set(
    enrollments
      .filter(cse => endedWithinAcademicYear(cse?.['schoolEnrollment.campusEnrollments.endDate'], academicYear))
      .map(cse => cse?.schoolEnrollmentId),
  )
  const seen = new Set()
  const visible = enrollments.filter(cse => {
    if (inactiveIds.has(cse?.schoolEnrollmentId) || seen.has(cse?.schoolEnrollmentId)) return false
    seen.add(cse?.schoolEnrollmentId)
    return true
  })
  const leads = visible.filter(cse => cse?.roleId === 'lead-teacher')
  const others = visible.filter(cse => cse?.roleId && cse?.roleId !== 'lead-teacher')

  if (leads.length === 0) {
    return <Chip icon={<Info />} color="error" size="small" label="No Lead Teacher" variant="outlined" />
  }
  if (leads.length > 1) {
    return <Chip icon={<Info />} color="warning" size="small" label="Multiple Lead Teachers" variant="outlined" />
  }

  const lead = leads[0]
  const leadName = `${lead.lastName}, ${lead.firstName}`
  if (!others.length) return <Typography variant="body2">{leadName}</Typography>

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <Typography variant="body2">{leadName}</Typography>
      <Tooltip
        arrow
        title={
          <Stack>
            {others.map((teacher, i) => (
              <Typography variant="body2" key={i}>
                {teacher.lastName}, {teacher.firstName}
                {staffRole && ` (${staffRole.find(r => r.id === teacher.roleId)?.name ?? ''})`}
              </Typography>
            ))}
          </Stack>
        }
      >
        <Typography variant="body2" sx={{ cursor: 'pointer', color: 'primary.main' }}>
          +{others.length}
        </Typography>
      </Tooltip>
    </Stack>
  )
}
